// @flow
import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {PARAMETERS} from "../../locales/namespaces";
import useOrigins from "../../hooks/useOrigins";
import DataGridWrapper from "../../../../components/dataGridWrapper/dataGridWrapper";
import {GridEditInputCell} from '@mui/x-data-grid-premium';
import {withPermissionHOC} from "../../../permission/components/permissionHOC/permissionHOC";
import {Typography} from "@mui/material";
import MainCard from "../../../../theme/mantis/components/mainCard";
import ContentLoader from "../../../../components/contentLoader/contentLoader";
import EditableMUIDataGrid from "../../../../components/editableMUIDataGrid/editableMUIDataGrid";
import {CustomPagination} from "../../../../components/dataGridCustom/customPagination";
import EditableMUICellValidation from "../../../../components/editableMUICellValidation/editableMUICellValidation";

type Props = {
	circularLoader?: boolean
}

const Origins = (props: Props) => {
	const {t} = useTranslation(PARAMETERS)
	const {
		loading,
		origins,
		update
	} = useOrigins()
	
	const {circularLoader} = props
	
	const newRowModel = {
		DescriptionEl: '',
		DescriptionEn: '',
		ErpCode: '',
		isRecommendation: false
	}
	
	const columns = useMemo(() => [
		{
			field: 'ErpCode',
			headerName: t('Erp Code'),
			minWidth: 200,
			flex: 1,
		},
		{
			field: 'isRecommendation',
			headerName: t('Recommendation'),
			width: 110, maxWidth: 150, flex: 1,
			type: 'boolean',
			editable: true,
			valueGetter: ({value}) => value === '1'
		},
		{
			field: 'DescriptionEl',
			headerName: t('Description EL'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return {...params.props, error: t('Required')};
				}
				return {...params.props, error: null}; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
		{
			field: 'DescriptionEn',
			headerName: t('Description EN'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return {...params.props, error: t('Required')};
				}
				return {...params.props, error: null}; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
	], [origins, t])
	
	return !loading ? (
		<MainCard
			title={
				<Typography variant="h5" gutterBottom>
					{t('Origin')}
				</Typography>
			}
			sx={{mt: 2}}
		>
			<DataGridWrapper
				autoHeight
				sx={{
					maxWidth: '1000px',
				}}
			>
				<EditableMUIDataGrid
					sx={{maxHeight: 600}}
					loading={loading}
					data={origins}
					columns={columns}
					newRowModel={newRowModel}
					update={update}
					dataGridProOtherProps={{
						disableColumnMenu: true,
						slots: {
							toolbar: false,
							pagination: CustomPagination,
						}
					}}
					hideDeleteButton={true}
				/>
			</DataGridWrapper>
		</MainCard>
	) : (
		<ContentLoader
			loading={loading}
			useCircularLoader={circularLoader}
		/>
	)
}

export default withPermissionHOC(Origins, ['access_parameters'])